import { defineFetch } from 'resift';

const makeGetRoles = defineFetch({
  displayName: 'Get Roles',
  make: () => ({
    request: (query?: any) => ({ http }) =>
      http({
        method: 'GET',
        route: `/roles`,
        query,
      }),
  }),
});

const getRoles = makeGetRoles();

export default getRoles;
